import FormularioTarea from "./FormularioTarea";

export const AgregarTarea = () => {
  return (
    <div className="container">
      <h1
        className="text-center"
        style={{ marginTop: "5%", marginBottom: "5%" }}
      >
        Agregar una nueva tarea
      </h1>
      <FormularioTarea id={null} tarea={null} />
    </div>
  );
};
